import { render, staticRenderFns } from "./ActivityItemApproval.vue?vue&type=template&id=0edb6c7a"
import script from "./ActivityItemApproval.vue?vue&type=script&lang=js"
export * from "./ActivityItemApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports